/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './purchasing-product.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/flex-layout/flexbox/api/layout';
import * as i3 from '@angular/flex-layout/media-query/media-monitor';
import * as i4 from '@angular/flex-layout/flexbox/api/layout-gap';
import * as i5 from '@angular/flex-layout/flexbox/api/class';
import * as i6 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i7 from '@angular/material';
import * as i8 from '@angular/forms';
import * as i9 from '@angular/flex-layout/flexbox/api/flex';
import * as i10 from '@angular/flex-layout/flexbox/api/layout-wrap';
import * as i11 from '@angular/common';
import * as i12 from '@angular/platform-browser';
import * as i13 from '@angular/router';
import * as i14 from '@angular/flex-layout/flexbox/api/flex-align';
import * as i15 from '../../../../../../app/shared/pipes/translate.pipe';
import * as i16 from '@covalent/core/loading/directives/loading.directive';
import * as i17 from '@covalent/core/loading/services/loading.service';
import * as i18 from '../../../../../../app/agatextscreens/purchasing/products/product/purchasing-product.component';
import * as i19 from '../../../../../../$$_gendir/node_modules/@covalent/core/file/file-upload/file-upload.component.ngfactory';
import * as i20 from '@covalent/core/file/file-upload/file-upload.component';
import * as i21 from '@covalent/core/file/file-input/file-input.component';
import * as i22 from '../../../../../../app/shared/services/file-upload.service';
import * as i23 from '@angular/http';
import * as i24 from '../../../../../../app/app.constants';
import * as i25 from '../../../../../../app/shared/services/authentication.service';
import * as i26 from '../../../../../../app/agatextscreens/purchasing/products/product.service';
import * as i27 from '../../../../../../app/agatextscreens/purchasing/suppliers/supplier.service';
import * as i28 from '../../../../../../services/location.service';
import * as i29 from '@covalent/core/dialogs/services/dialog.service';
const styles_PurchasingProductComponent:any[] = [i0.styles];
export const RenderType_PurchasingProductComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PurchasingProductComponent,data:{}});
function View_PurchasingProductComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),13,'div',[['class',
      'padded-container unsaved-changes'],['fxLayout','row'],['fxLayoutGap','30px']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
      (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
      {layout:[0,'layout']},(null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,
          'gap']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
      [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-icon',[['role',
      'img']],[[2,'mat-icon',(null as any)]],(null as any),(null as any),i6.View_MdIcon_0,
      i6.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,
      i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i7.MdIcon,[i1.ElementRef,i1.Renderer2,i7.MdIconRegistry],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['warning'])),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n    ']))],(_ck,_v) => {
    const currVal_0:any = 'row';
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = '30px';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'padded-container unsaved-changes';
    _ck(_v,3,0,currVal_2);
    _ck(_v,7,0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_3:any = true;
    _ck(_v,5,0,currVal_3);
    const currVal_4:any = i1.ɵunv(_v,11,0,_ck(_v,12,0,i1.ɵnov((<any>_v.parent),0),
        'you_have_unsaved_changes',_co._authService.getLanguage()));
    _ck(_v,11,0,currVal_4);
  });
}
function View_PurchasingProductComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[2,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['','']))],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit.id;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_10);
  });
}
function View_PurchasingProductComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'md-hint',[['align',
      'end']],[[2,'mat-hint',(null as any)],[2,'mat-right',(null as any)],[1,'id',
      0]],(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,
      (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
      (null as any),(null as any)),i1.ɵdid(16384,[[6,4]],0,i7.MdHint,([] as any[]),
      {align:[0,'align']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                            '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',[['style','color:red']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n                        ']))],(_ck,_v) => {
    const currVal_3:any = 'end';
    _ck(_v,2,0,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    const currVal_1:any = (i1.ɵnov(_v,2).align == 'end');
    const currVal_2:any = i1.ɵnov(_v,2).id;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),
        0),'this_collection_will_be_created',_co._authService.getLanguage()));
    _ck(_v,5,0,currVal_4);
  });
}
function View_PurchasingProductComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[9,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['\n                                ',
          '\n                            ']))],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_10);
  });
}
function View_PurchasingProductComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'md-hint',[['align',
      'end']],[[2,'mat-hint',(null as any)],[2,'mat-right',(null as any)],[1,'id',
      0]],(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,
      (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
      (null as any),(null as any)),i1.ɵdid(16384,[[13,4]],0,i7.MdHint,([] as any[]),
      {align:[0,'align']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                            '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',[['style','color:red']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n                        ']))],(_ck,_v) => {
    const currVal_3:any = 'end';
    _ck(_v,2,0,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    const currVal_1:any = (i1.ɵnov(_v,2).align == 'end');
    const currVal_2:any = i1.ɵnov(_v,2).id;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),
        0),'enter_collection_first',_co._authService.getLanguage()));
    _ck(_v,5,0,currVal_4);
  });
}
function View_PurchasingProductComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'md-hint',[['align',
      'end']],[[2,'mat-hint',(null as any)],[2,'mat-right',(null as any)],[1,'id',
      0]],(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,
      (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
      (null as any),(null as any)),i1.ɵdid(16384,[[13,4]],0,i7.MdHint,([] as any[]),
      {align:[0,'align']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                            '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',[['style','color:red']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n                        ']))],(_ck,_v) => {
    const currVal_3:any = 'end';
    _ck(_v,2,0,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    const currVal_1:any = (i1.ɵnov(_v,2).align == 'end');
    const currVal_2:any = i1.ɵnov(_v,2).id;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),
        0),'this_design_will_be_created',_co._authService.getLanguage()));
    _ck(_v,5,0,currVal_4);
  });
}
function View_PurchasingProductComponent_9(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'md-hint',[['align',
      'end']],[[2,'mat-hint',(null as any)],[2,'mat-right',(null as any)],[1,'id',
      0]],(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,
      (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
      (null as any),(null as any)),i1.ɵdid(16384,[[13,4]],0,i7.MdHint,([] as any[]),
      {align:[0,'align']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                            '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',[['style','color:red']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['','?'])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n                        ']))],(_ck,_v) => {
    const currVal_3:any = 'end';
    _ck(_v,2,0,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    const currVal_1:any = (i1.ɵnov(_v,2).align == 'end');
    const currVal_2:any = i1.ɵnov(_v,2).id;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),
        0),'this_design_exists_as_part_of_another_collection_is_the_name_correct',
        _co._authService.getLanguage()));
    _ck(_v,5,0,currVal_4);
  });
}
function View_PurchasingProductComponent_10(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[16,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['\n                                ',
          '\n                            ']))],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_10);
  });
}
function View_PurchasingProductComponent_11(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[23,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['','']))],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit.id;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_10);
  });
}
function View_PurchasingProductComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),265,'md-card-content',
      [['fxLayout','column']],[[2,'mat-card-content',(null as any)]],(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardContent,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),110,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),13,'md-select',[['fxFlex','22%'],
          ['name','fabricType'],['role','listbox']],[[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)],[1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',
              0],[1,'aria-required',0],[1,'aria-disabled',0],[1,'aria-invalid',0],
          [1,'aria-owns',0],[2,'mat-select-disabled',(null as any)],[2,'mat-select',
              (null as any)]],[[(null as any),'ngModelChange'],[(null as any),'keydown'],
          [(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,15)._handleClosedKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,15)._onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_2:any = ((<any>(_co.currentProduct.fabric_type_id = $event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i6.View_MdSelect_0,i6.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),0,
          i8.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,(null as any)]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i8.NgControl,(null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),
          0,i8.NgControlStatus,[i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          1,i7.MdSelect,[i1.ElementRef,i1.Renderer2,i7.ViewportRuler,i1.ChangeDetectorRef,
              [2,i7.Dir],[2,i8.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵqud(603979776,2,{options:1}),i1.ɵppd(2),i1.ɵdid(737280,
          (null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,'flex']},
          (null as any)),(_l()(),i1.ɵted(0,['\n                        '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,2,(null as any),View_PurchasingProductComponent_4)),
      i1.ɵdid(802816,(null as any),0,i11.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpid(131072,
          i11.AsyncPipe,[i1.ChangeDetectorRef]),(_l()(),i1.ɵted(0,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),31,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,26)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,3,{_mdInputChild:0}),i1.ɵqud(335544320,4,{_placeholderChild:0}),
      i1.ɵqud(603979776,5,{_errorChildren:1}),i1.ɵqud(603979776,6,{_hintChildren:1}),
      i1.ɵqud(603979776,7,{_prefixChildren:1}),i1.ɵqud(603979776,8,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(16777216,(null as any),1,8,'input',[['aria-autocomplete','list'],
          ['aria-multiline','false'],['autocomplete','off'],['mdInput',''],['role',
              'combobox']],[[1,'aria-activedescendant',0],[1,'aria-expanded',0],[1,
          'aria-owns',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],
          [2,'mat-input-element',(null as any)],[8,'id',0],[8,'placeholder',0],[8,
              'disabled',0],[8,'required',0],[1,'aria-describedby',0]],[[(null as any),
          'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
          'compositionstart'],[(null as any),'compositionend'],[(null as any),'focus'],
          [(null as any),'keydown']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,36)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,36).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,36)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,36)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('focus' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,37).openPanel()) !== false);
          ad = (pd_4 && ad);
        }
        if (('input' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,37)._handleInput($event)) !== false);
          ad = (pd_5 && ad);
        }
        if (('blur' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,37)._onTouched()) !== false);
          ad = (pd_6 && ad);
        }
        if (('keydown' === en)) {
          const pd_7:any = ((<any>i1.ɵnov(_v,37)._handleKeydown($event)) !== false);
          ad = (pd_7 && ad);
        }
        if (('blur' === en)) {
          const pd_8:any = ((<any>i1.ɵnov(_v,42)._onBlur()) !== false);
          ad = (pd_8 && ad);
        }
        if (('focus' === en)) {
          const pd_9:any = ((<any>i1.ɵnov(_v,42)._onFocus()) !== false);
          ad = (pd_9 && ad);
        }
        if (('input' === en)) {
          const pd_10:any = ((<any>i1.ɵnov(_v,42)._onInput()) !== false);
          ad = (pd_10 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_11:any = ((<any>(_co.currentProduct.collection_name = $event)) !== false);
          ad = (pd_11 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_12:any = ((<any>_co.filterCollections($event,true)) !== false);
          ad = (pd_12 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(147456,(null as any),0,i7.MdAutocompleteTrigger,[i1.ElementRef,
          i7.Overlay,i1.ViewContainerRef,i1.ChangeDetectorRef,i7.ScrollDispatcher,
          [2,i7.Dir],i1.NgZone,[2,i7.MdInputContainer],[2,i12.DOCUMENT]],{autocomplete:[0,
          'autocomplete']},(null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i8.DefaultValueAccessor,i7.MdAutocompleteTrigger]),i1.ɵdid(671744,(null as any),
          0,i8.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i8.NgControl,(null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[3,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n\n                        '])),
      (_l()(),i1.ɵand(16777216,(null as any),6,1,(null as any),View_PurchasingProductComponent_5)),
      i1.ɵdid(16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(1,['\n\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'md-autocomplete',([] as any[]),[[2,'mat-autocomplete',
          (null as any)]],(null as any),(null as any),i6.View_MdAutocomplete_0,i6.RenderType_MdAutocomplete)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1097728,[['collAuto',
          4]],1,i7.MdAutocomplete,[i1.ChangeDetectorRef],(null as any),(null as any)),
      i1.ɵqud(603979776,9,{options:1}),(_l()(),i1.ɵted(0,['\n                            '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_PurchasingProductComponent_6)),
      i1.ɵdid(802816,(null as any),0,i11.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n                        '])),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),36,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,59)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,10,{_mdInputChild:0}),i1.ɵqud(335544320,11,{_placeholderChild:0}),
      i1.ɵqud(603979776,12,{_errorChildren:1}),i1.ɵqud(603979776,13,{_hintChildren:1}),
      i1.ɵqud(603979776,14,{_prefixChildren:1}),i1.ɵqud(603979776,15,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(16777216,(null as any),1,7,'input',[['aria-autocomplete','list'],
          ['aria-multiline','false'],['autocomplete','off'],['mdInput',''],['placeholder',
              'Design'],['role','combobox']],[[1,'aria-activedescendant',0],[1,'aria-expanded',
          0],[1,'aria-owns',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],
          [2,'mat-input-element',(null as any)],[8,'id',0],[8,'placeholder',0],[8,
              'disabled',0],[8,'required',0],[1,'aria-describedby',0]],[[(null as any),
          'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
          'compositionstart'],[(null as any),'compositionend'],[(null as any),'focus'],
          [(null as any),'keydown']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,69)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,69).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,69)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,69)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('focus' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,70).openPanel()) !== false);
          ad = (pd_4 && ad);
        }
        if (('input' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,70)._handleInput($event)) !== false);
          ad = (pd_5 && ad);
        }
        if (('blur' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,70)._onTouched()) !== false);
          ad = (pd_6 && ad);
        }
        if (('keydown' === en)) {
          const pd_7:any = ((<any>i1.ɵnov(_v,70)._handleKeydown($event)) !== false);
          ad = (pd_7 && ad);
        }
        if (('blur' === en)) {
          const pd_8:any = ((<any>i1.ɵnov(_v,75)._onBlur()) !== false);
          ad = (pd_8 && ad);
        }
        if (('focus' === en)) {
          const pd_9:any = ((<any>i1.ɵnov(_v,75)._onFocus()) !== false);
          ad = (pd_9 && ad);
        }
        if (('input' === en)) {
          const pd_10:any = ((<any>i1.ɵnov(_v,75)._onInput()) !== false);
          ad = (pd_10 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_11:any = ((<any>(_co.currentProduct.design_name = $event)) !== false);
          ad = (pd_11 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_12:any = ((<any>_co.filterDesigns($event,true)) !== false);
          ad = (pd_12 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(147456,(null as any),0,i7.MdAutocompleteTrigger,[i1.ElementRef,
          i7.Overlay,i1.ViewContainerRef,i1.ChangeDetectorRef,i7.ScrollDispatcher,
          [2,i7.Dir],i1.NgZone,[2,i7.MdInputContainer],[2,i12.DOCUMENT]],{autocomplete:[0,
          'autocomplete']},(null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i8.DefaultValueAccessor,i7.MdAutocompleteTrigger]),i1.ɵdid(671744,(null as any),
          0,i8.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i8.NgControl,(null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[10,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),(_l()(),i1.ɵted(1,['\n\n                        '])),(_l()(),
          i1.ɵand(16777216,(null as any),6,1,(null as any),View_PurchasingProductComponent_7)),
      i1.ɵdid(16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(1,['\n\n                        '])),
      (_l()(),i1.ɵand(16777216,(null as any),6,1,(null as any),View_PurchasingProductComponent_8)),
      i1.ɵdid(16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(1,['\n\n                        '])),
      (_l()(),i1.ɵand(16777216,(null as any),6,1,(null as any),View_PurchasingProductComponent_9)),
      i1.ɵdid(16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(1,['\n\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'md-autocomplete',([] as any[]),[[2,'mat-autocomplete',
          (null as any)]],(null as any),(null as any),i6.View_MdAutocomplete_0,i6.RenderType_MdAutocomplete)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1097728,[['desAuto',
          4]],1,i7.MdAutocomplete,[i1.ChangeDetectorRef],(null as any),(null as any)),
      i1.ɵqud(603979776,16,{options:1}),(_l()(),i1.ɵted(0,['\n                            '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_PurchasingProductComponent_10)),
      i1.ɵdid(802816,(null as any),0,i11.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n                        '])),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),18,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,97)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,17,{_mdInputChild:0}),i1.ɵqud(335544320,18,{_placeholderChild:0}),
      i1.ɵqud(603979776,19,{_errorChildren:1}),i1.ɵqud(603979776,20,{_hintChildren:1}),
      i1.ɵqud(603979776,21,{_prefixChildren:1}),i1.ɵqud(603979776,22,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,107)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,107).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,107)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,107)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,112)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,112)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,112)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentProduct.name = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[17,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),60,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),13,'md-select',[['fxFlex','22%'],
          ['name','countryOfOrigin'],['role','listbox']],[[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)],[1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',
              0],[1,'aria-required',0],[1,'aria-disabled',0],[1,'aria-invalid',0],
          [1,'aria-owns',0],[2,'mat-select-disabled',(null as any)],[2,'mat-select',
              (null as any)]],[[(null as any),'ngModelChange'],[(null as any),'keydown'],
          [(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,127)._handleClosedKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,127)._onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_2:any = ((<any>(_co.currentProduct.country_of_origin_id = $event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i6.View_MdSelect_0,i6.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),0,
          i8.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,(null as any)]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i8.NgControl,(null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),
          0,i8.NgControlStatus,[i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          1,i7.MdSelect,[i1.ElementRef,i1.Renderer2,i7.ViewportRuler,i1.ChangeDetectorRef,
              [2,i7.Dir],[2,i8.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵqud(603979776,23,{options:1}),i1.ɵppd(2),i1.ɵdid(737280,
          (null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,'flex']},
          (null as any)),(_l()(),i1.ɵted(0,['\n                        '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,2,(null as any),View_PurchasingProductComponent_11)),
      i1.ɵdid(802816,(null as any),0,i11.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpid(131072,
          i11.AsyncPipe,[i1.ChangeDetectorRef]),(_l()(),i1.ɵted(0,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          18,'md-input-container',[['fxFlex','22%']],[[1,'align',0],[2,'mat-input-container',
              (null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-focused',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,139)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,24,{_mdInputChild:0}),i1.ɵqud(335544320,25,{_placeholderChild:0}),
      i1.ɵqud(603979776,26,{_errorChildren:1}),i1.ɵqud(603979776,27,{_hintChildren:1}),
      i1.ɵqud(603979776,28,{_prefixChildren:1}),i1.ɵqud(603979776,29,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,149)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,149).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,149)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,149)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,154)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,154)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,154)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentProduct.customs_code = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[24,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),18,'md-input-container',[['fxFlex','47%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,159)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,30,{_mdInputChild:0}),i1.ɵqud(335544320,31,{_placeholderChild:0}),
      i1.ɵqud(603979776,32,{_errorChildren:1}),i1.ɵqud(603979776,33,{_hintChildren:1}),
      i1.ɵqud(603979776,34,{_prefixChildren:1}),i1.ɵqud(603979776,35,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,169)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,169).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,169)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,169)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,174)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,174)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,174)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentProduct.composition = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[30,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),59,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,185)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,36,{_mdInputChild:0}),i1.ɵqud(335544320,37,{_placeholderChild:0}),
      i1.ɵqud(603979776,38,{_errorChildren:1}),i1.ɵqud(603979776,39,{_hintChildren:1}),
      i1.ɵqud(603979776,40,{_prefixChildren:1}),i1.ɵqud(603979776,41,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,195)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,195).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,195)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,195)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,200)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,200)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,200)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentProduct.weight_gsm = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[36,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),18,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,205)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,42,{_mdInputChild:0}),i1.ɵqud(335544320,43,{_placeholderChild:0}),
      i1.ɵqud(603979776,44,{_errorChildren:1}),i1.ɵqud(603979776,45,{_hintChildren:1}),
      i1.ɵqud(603979776,46,{_prefixChildren:1}),i1.ɵqud(603979776,47,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,215)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,215).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,215)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,215)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,220)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,220)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,220)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentProduct.width = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[42,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),13,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,225)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,48,{_mdInputChild:0}),i1.ɵqud(335544320,49,{_placeholderChild:0}),
      i1.ɵqud(603979776,50,{_errorChildren:1}),i1.ɵqud(603979776,51,{_hintChildren:1}),
      i1.ɵqud(603979776,52,{_prefixChildren:1}),i1.ɵqud(603979776,53,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,2,'input',[['mdInput',''],['readonly','']],
          [[8,'value',0],[2,'mat-input-element',(null as any)],[8,'id',0],[8,'placeholder',
              0],[8,'disabled',0],[8,'required',0],[1,'aria-describedby',0]],[[(null as any),
              'blur'],[(null as any),'focus'],[(null as any),'input']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('blur' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,235)._onBlur()) !== false);
              ad = (pd_0 && ad);
            }
            if (('focus' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,235)._onFocus()) !== false);
              ad = (pd_1 && ad);
            }
            if (('input' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,235)._onInput()) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,[[48,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),24,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '47%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,246)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,54,{_mdInputChild:0}),i1.ɵqud(335544320,55,{_placeholderChild:0}),
      i1.ɵqud(603979776,56,{_errorChildren:1}),i1.ɵqud(603979776,57,{_hintChildren:1}),
      i1.ɵqud(603979776,58,{_prefixChildren:1}),i1.ɵqud(603979776,59,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'textarea',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,256)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,256).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,256)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,256)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,261)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,261)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,261)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentProduct.notes = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[54,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n            ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'column';
    _ck(_v,3,0,currVal_1);
    const currVal_2:any = 'row';
    const currVal_3:any = 'column';
    _ck(_v,6,0,currVal_2,currVal_3);
    const currVal_4:any = '30px';
    const currVal_5:any = '14px';
    _ck(_v,7,0,currVal_4,currVal_5);
    const currVal_6:any = 'padded-container';
    _ck(_v,8,0,currVal_6);
    const currVal_23:any = 'fabricType';
    const currVal_24:any = _co.currentProduct.fabric_type_id;
    _ck(_v,11,0,currVal_23,currVal_24);
    const currVal_25:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,15,0,_ck(_v,17,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'fabric_type',_co._authService.getLanguage())),
        '');
    _ck(_v,15,0,currVal_25);
    const currVal_26:any = '22%';
    _ck(_v,18,0,currVal_26);
    const currVal_27:any = i1.ɵunv(_v,21,0,i1.ɵnov(_v,22).transform(_co.allFabricTypes$));
    _ck(_v,21,0,currVal_27);
    const currVal_39:any = '22%';
    _ck(_v,33,0,currVal_39);
    const currVal_56:any = i1.ɵnov(_v,50);
    _ck(_v,37,0,currVal_56);
    const currVal_57:any = _co.currentProduct.collection_name;
    _ck(_v,39,0,currVal_57);
    const currVal_58:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,42,0,_ck(_v,43,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'collection',_co._authService.getLanguage())),
        '');
    _ck(_v,42,0,currVal_58);
    const currVal_59:boolean = !_co.collectionExists(_co.currentProduct.collection_name);
    _ck(_v,46,0,currVal_59);
    const currVal_61:any = _co.collections;
    _ck(_v,54,0,currVal_61);
    const currVal_73:any = '22%';
    _ck(_v,66,0,currVal_73);
    const currVal_90:any = i1.ɵnov(_v,88);
    _ck(_v,70,0,currVal_90);
    const currVal_91:any = _co.currentProduct.design_name;
    _ck(_v,72,0,currVal_91);
    const currVal_92:any = 'Design';
    _ck(_v,75,0,currVal_92);
    const currVal_93:boolean = !_co.currentProduct.collection_name;
    _ck(_v,78,0,currVal_93);
    const currVal_94:any = (_co.currentProduct.collection_name && !_co.designExists(_co.currentProduct.design_name));
    _ck(_v,81,0,currVal_94);
    const currVal_95:any = ((_co.currentProduct.collection_name && _co.designExists(_co.currentProduct.design_name)) && !_co.designInCollection(_co.currentProduct.collection_name,
        _co.currentProduct.design_name));
    _ck(_v,84,0,currVal_95);
    const currVal_97:any = _co.designs;
    _ck(_v,92,0,currVal_97);
    const currVal_109:any = '22%';
    _ck(_v,104,0,currVal_109);
    const currVal_123:any = _co.currentProduct.name;
    _ck(_v,109,0,currVal_123);
    const currVal_124:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,112,0,_ck(_v,113,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'color',_co._authService.getLanguage())),
        '');
    _ck(_v,112,0,currVal_124);
    const currVal_125:any = 'row';
    const currVal_126:any = 'column';
    _ck(_v,118,0,currVal_125,currVal_126);
    const currVal_127:any = '30px';
    const currVal_128:any = '14px';
    _ck(_v,119,0,currVal_127,currVal_128);
    const currVal_129:any = 'padded-container';
    _ck(_v,120,0,currVal_129);
    const currVal_146:any = 'countryOfOrigin';
    const currVal_147:any = _co.currentProduct.country_of_origin_id;
    _ck(_v,123,0,currVal_146,currVal_147);
    const currVal_148:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,127,0,_ck(_v,129,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'country_of_origin',_co._authService.getLanguage())),
        '');
    _ck(_v,127,0,currVal_148);
    const currVal_149:any = '22%';
    _ck(_v,130,0,currVal_149);
    const currVal_150:any = i1.ɵunv(_v,133,0,i1.ɵnov(_v,134).transform(_co.allCountriesOfOrigin$));
    _ck(_v,133,0,currVal_150);
    const currVal_162:any = '22%';
    _ck(_v,146,0,currVal_162);
    const currVal_176:any = _co.currentProduct.customs_code;
    _ck(_v,151,0,currVal_176);
    const currVal_177:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,154,0,_ck(_v,155,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'customs_code',_co._authService.getLanguage())),
        '');
    _ck(_v,154,0,currVal_177);
    const currVal_189:any = '47%';
    _ck(_v,166,0,currVal_189);
    const currVal_203:any = _co.currentProduct.composition;
    _ck(_v,171,0,currVal_203);
    const currVal_204:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,174,0,_ck(_v,175,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'composition',_co._authService.getLanguage())),
        '');
    _ck(_v,174,0,currVal_204);
    const currVal_205:any = 'row';
    const currVal_206:any = 'column';
    _ck(_v,180,0,currVal_205,currVal_206);
    const currVal_207:any = '30px';
    const currVal_208:any = '14px';
    _ck(_v,181,0,currVal_207,currVal_208);
    const currVal_209:any = 'padded-container';
    _ck(_v,182,0,currVal_209);
    const currVal_221:any = '22%';
    _ck(_v,192,0,currVal_221);
    const currVal_235:any = _co.currentProduct.weight_gsm;
    _ck(_v,197,0,currVal_235);
    const currVal_236:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,200,0,_ck(_v,201,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'weight_gsm',_co._authService.getLanguage())),
        '');
    _ck(_v,200,0,currVal_236);
    const currVal_248:any = '22%';
    _ck(_v,212,0,currVal_248);
    const currVal_262:any = _co.currentProduct.width;
    _ck(_v,217,0,currVal_262);
    const currVal_263:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,220,0,_ck(_v,221,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'width',_co._authService.getLanguage())),
        ' (CM)');
    _ck(_v,220,0,currVal_263);
    const currVal_275:any = '22%';
    _ck(_v,232,0,currVal_275);
    const currVal_283:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,235,0,_ck(_v,236,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'design_unit_price',_co._authService.getLanguage())),
        '');
    _ck(_v,235,0,currVal_283);
    const currVal_284:any = 'row';
    const currVal_285:any = 'column';
    _ck(_v,241,0,currVal_284,currVal_285);
    const currVal_286:any = '30px';
    const currVal_287:any = '14px';
    _ck(_v,242,0,currVal_286,currVal_287);
    const currVal_288:any = 'padded-container';
    _ck(_v,243,0,currVal_288);
    const currVal_300:any = '47%';
    _ck(_v,253,0,currVal_300);
    const currVal_314:any = _co.currentProduct.notes;
    _ck(_v,258,0,currVal_314);
    const currVal_315:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,261,0,_ck(_v,262,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'notes',_co._authService.getLanguage())),
        '');
    _ck(_v,261,0,currVal_315);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_7:any = i1.ɵnov(_v,13).ngClassUntouched;
    const currVal_8:any = i1.ɵnov(_v,13).ngClassTouched;
    const currVal_9:any = i1.ɵnov(_v,13).ngClassPristine;
    const currVal_10:any = i1.ɵnov(_v,13).ngClassDirty;
    const currVal_11:any = i1.ɵnov(_v,13).ngClassValid;
    const currVal_12:any = i1.ɵnov(_v,13).ngClassInvalid;
    const currVal_13:any = i1.ɵnov(_v,13).ngClassPending;
    const currVal_14:any = i1.ɵnov(_v,15).tabIndex;
    const currVal_15:any = i1.ɵnov(_v,15)._ariaLabel;
    const currVal_16:any = i1.ɵnov(_v,15).ariaLabelledby;
    const currVal_17:any = i1.ɵnov(_v,15).required.toString();
    const currVal_18:any = i1.ɵnov(_v,15).disabled.toString();
    const currVal_19:any = (((i1.ɵnov(_v,15)._control == null)? (null as any): i1.ɵnov(_v,
        15)._control.invalid) || 'false');
    const currVal_20:any = i1.ɵnov(_v,15)._optionIds;
    const currVal_21:any = i1.ɵnov(_v,15).disabled;
    const currVal_22:any = true;
    _ck(_v,10,1,[currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
        currVal_14,currVal_15,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,
        currVal_21,currVal_22]);
    const currVal_28:any = (null as any);
    const currVal_29:any = true;
    const currVal_30:any = i1.ɵnov(_v,26)._isErrorState();
    const currVal_31:any = i1.ɵnov(_v,26)._mdInputChild.focused;
    const currVal_32:any = i1.ɵnov(_v,26)._shouldForward('untouched');
    const currVal_33:any = i1.ɵnov(_v,26)._shouldForward('touched');
    const currVal_34:any = i1.ɵnov(_v,26)._shouldForward('pristine');
    const currVal_35:any = i1.ɵnov(_v,26)._shouldForward('dirty');
    const currVal_36:any = i1.ɵnov(_v,26)._shouldForward('valid');
    const currVal_37:any = i1.ɵnov(_v,26)._shouldForward('invalid');
    const currVal_38:any = i1.ɵnov(_v,26)._shouldForward('pending');
    _ck(_v,25,1,[currVal_28,currVal_29,currVal_30,currVal_31,currVal_32,currVal_33,
        currVal_34,currVal_35,currVal_36,currVal_37,currVal_38]);
    const currVal_40:any = ((i1.ɵnov(_v,37).activeOption == null)? (null as any): i1.ɵnov(_v,
        37).activeOption.id);
    const currVal_41:any = i1.ɵnov(_v,37).panelOpen.toString();
    const currVal_42:any = ((i1.ɵnov(_v,37).autocomplete == null)? (null as any): i1.ɵnov(_v,
        37).autocomplete.id);
    const currVal_43:any = i1.ɵnov(_v,41).ngClassUntouched;
    const currVal_44:any = i1.ɵnov(_v,41).ngClassTouched;
    const currVal_45:any = i1.ɵnov(_v,41).ngClassPristine;
    const currVal_46:any = i1.ɵnov(_v,41).ngClassDirty;
    const currVal_47:any = i1.ɵnov(_v,41).ngClassValid;
    const currVal_48:any = i1.ɵnov(_v,41).ngClassInvalid;
    const currVal_49:any = i1.ɵnov(_v,41).ngClassPending;
    const currVal_50:any = true;
    const currVal_51:any = i1.ɵnov(_v,42).id;
    const currVal_52:any = i1.ɵnov(_v,42).placeholder;
    const currVal_53:any = i1.ɵnov(_v,42).disabled;
    const currVal_54:any = i1.ɵnov(_v,42).required;
    const currVal_55:any = (i1.ɵnov(_v,42).ariaDescribedby || (null as any));
    _ck(_v,35,1,[currVal_40,currVal_41,currVal_42,currVal_43,currVal_44,currVal_45,
        currVal_46,currVal_47,currVal_48,currVal_49,currVal_50,currVal_51,currVal_52,
        currVal_53,currVal_54,currVal_55]);
    const currVal_60:any = true;
    _ck(_v,48,0,currVal_60);
    const currVal_62:any = (null as any);
    const currVal_63:any = true;
    const currVal_64:any = i1.ɵnov(_v,59)._isErrorState();
    const currVal_65:any = i1.ɵnov(_v,59)._mdInputChild.focused;
    const currVal_66:any = i1.ɵnov(_v,59)._shouldForward('untouched');
    const currVal_67:any = i1.ɵnov(_v,59)._shouldForward('touched');
    const currVal_68:any = i1.ɵnov(_v,59)._shouldForward('pristine');
    const currVal_69:any = i1.ɵnov(_v,59)._shouldForward('dirty');
    const currVal_70:any = i1.ɵnov(_v,59)._shouldForward('valid');
    const currVal_71:any = i1.ɵnov(_v,59)._shouldForward('invalid');
    const currVal_72:any = i1.ɵnov(_v,59)._shouldForward('pending');
    _ck(_v,58,1,[currVal_62,currVal_63,currVal_64,currVal_65,currVal_66,currVal_67,
        currVal_68,currVal_69,currVal_70,currVal_71,currVal_72]);
    const currVal_74:any = ((i1.ɵnov(_v,70).activeOption == null)? (null as any): i1.ɵnov(_v,
        70).activeOption.id);
    const currVal_75:any = i1.ɵnov(_v,70).panelOpen.toString();
    const currVal_76:any = ((i1.ɵnov(_v,70).autocomplete == null)? (null as any): i1.ɵnov(_v,
        70).autocomplete.id);
    const currVal_77:any = i1.ɵnov(_v,74).ngClassUntouched;
    const currVal_78:any = i1.ɵnov(_v,74).ngClassTouched;
    const currVal_79:any = i1.ɵnov(_v,74).ngClassPristine;
    const currVal_80:any = i1.ɵnov(_v,74).ngClassDirty;
    const currVal_81:any = i1.ɵnov(_v,74).ngClassValid;
    const currVal_82:any = i1.ɵnov(_v,74).ngClassInvalid;
    const currVal_83:any = i1.ɵnov(_v,74).ngClassPending;
    const currVal_84:any = true;
    const currVal_85:any = i1.ɵnov(_v,75).id;
    const currVal_86:any = i1.ɵnov(_v,75).placeholder;
    const currVal_87:any = i1.ɵnov(_v,75).disabled;
    const currVal_88:any = i1.ɵnov(_v,75).required;
    const currVal_89:any = (i1.ɵnov(_v,75).ariaDescribedby || (null as any));
    _ck(_v,68,1,[currVal_74,currVal_75,currVal_76,currVal_77,currVal_78,currVal_79,
        currVal_80,currVal_81,currVal_82,currVal_83,currVal_84,currVal_85,currVal_86,
        currVal_87,currVal_88,currVal_89]);
    const currVal_96:any = true;
    _ck(_v,86,0,currVal_96);
    const currVal_98:any = (null as any);
    const currVal_99:any = true;
    const currVal_100:any = i1.ɵnov(_v,97)._isErrorState();
    const currVal_101:any = i1.ɵnov(_v,97)._mdInputChild.focused;
    const currVal_102:any = i1.ɵnov(_v,97)._shouldForward('untouched');
    const currVal_103:any = i1.ɵnov(_v,97)._shouldForward('touched');
    const currVal_104:any = i1.ɵnov(_v,97)._shouldForward('pristine');
    const currVal_105:any = i1.ɵnov(_v,97)._shouldForward('dirty');
    const currVal_106:any = i1.ɵnov(_v,97)._shouldForward('valid');
    const currVal_107:any = i1.ɵnov(_v,97)._shouldForward('invalid');
    const currVal_108:any = i1.ɵnov(_v,97)._shouldForward('pending');
    _ck(_v,96,1,[currVal_98,currVal_99,currVal_100,currVal_101,currVal_102,currVal_103,
        currVal_104,currVal_105,currVal_106,currVal_107,currVal_108]);
    const currVal_110:any = i1.ɵnov(_v,111).ngClassUntouched;
    const currVal_111:any = i1.ɵnov(_v,111).ngClassTouched;
    const currVal_112:any = i1.ɵnov(_v,111).ngClassPristine;
    const currVal_113:any = i1.ɵnov(_v,111).ngClassDirty;
    const currVal_114:any = i1.ɵnov(_v,111).ngClassValid;
    const currVal_115:any = i1.ɵnov(_v,111).ngClassInvalid;
    const currVal_116:any = i1.ɵnov(_v,111).ngClassPending;
    const currVal_117:any = true;
    const currVal_118:any = i1.ɵnov(_v,112).id;
    const currVal_119:any = i1.ɵnov(_v,112).placeholder;
    const currVal_120:any = i1.ɵnov(_v,112).disabled;
    const currVal_121:any = i1.ɵnov(_v,112).required;
    const currVal_122:any = (i1.ɵnov(_v,112).ariaDescribedby || (null as any));
    _ck(_v,106,1,[currVal_110,currVal_111,currVal_112,currVal_113,currVal_114,currVal_115,
        currVal_116,currVal_117,currVal_118,currVal_119,currVal_120,currVal_121,currVal_122]);
    const currVal_130:any = i1.ɵnov(_v,125).ngClassUntouched;
    const currVal_131:any = i1.ɵnov(_v,125).ngClassTouched;
    const currVal_132:any = i1.ɵnov(_v,125).ngClassPristine;
    const currVal_133:any = i1.ɵnov(_v,125).ngClassDirty;
    const currVal_134:any = i1.ɵnov(_v,125).ngClassValid;
    const currVal_135:any = i1.ɵnov(_v,125).ngClassInvalid;
    const currVal_136:any = i1.ɵnov(_v,125).ngClassPending;
    const currVal_137:any = i1.ɵnov(_v,127).tabIndex;
    const currVal_138:any = i1.ɵnov(_v,127)._ariaLabel;
    const currVal_139:any = i1.ɵnov(_v,127).ariaLabelledby;
    const currVal_140:any = i1.ɵnov(_v,127).required.toString();
    const currVal_141:any = i1.ɵnov(_v,127).disabled.toString();
    const currVal_142:any = (((i1.ɵnov(_v,127)._control == null)? (null as any): i1.ɵnov(_v,
        127)._control.invalid) || 'false');
    const currVal_143:any = i1.ɵnov(_v,127)._optionIds;
    const currVal_144:any = i1.ɵnov(_v,127).disabled;
    const currVal_145:any = true;
    _ck(_v,122,1,[currVal_130,currVal_131,currVal_132,currVal_133,currVal_134,currVal_135,
        currVal_136,currVal_137,currVal_138,currVal_139,currVal_140,currVal_141,currVal_142,
        currVal_143,currVal_144,currVal_145]);
    const currVal_151:any = (null as any);
    const currVal_152:any = true;
    const currVal_153:any = i1.ɵnov(_v,139)._isErrorState();
    const currVal_154:any = i1.ɵnov(_v,139)._mdInputChild.focused;
    const currVal_155:any = i1.ɵnov(_v,139)._shouldForward('untouched');
    const currVal_156:any = i1.ɵnov(_v,139)._shouldForward('touched');
    const currVal_157:any = i1.ɵnov(_v,139)._shouldForward('pristine');
    const currVal_158:any = i1.ɵnov(_v,139)._shouldForward('dirty');
    const currVal_159:any = i1.ɵnov(_v,139)._shouldForward('valid');
    const currVal_160:any = i1.ɵnov(_v,139)._shouldForward('invalid');
    const currVal_161:any = i1.ɵnov(_v,139)._shouldForward('pending');
    _ck(_v,138,1,[currVal_151,currVal_152,currVal_153,currVal_154,currVal_155,currVal_156,
        currVal_157,currVal_158,currVal_159,currVal_160,currVal_161]);
    const currVal_163:any = i1.ɵnov(_v,153).ngClassUntouched;
    const currVal_164:any = i1.ɵnov(_v,153).ngClassTouched;
    const currVal_165:any = i1.ɵnov(_v,153).ngClassPristine;
    const currVal_166:any = i1.ɵnov(_v,153).ngClassDirty;
    const currVal_167:any = i1.ɵnov(_v,153).ngClassValid;
    const currVal_168:any = i1.ɵnov(_v,153).ngClassInvalid;
    const currVal_169:any = i1.ɵnov(_v,153).ngClassPending;
    const currVal_170:any = true;
    const currVal_171:any = i1.ɵnov(_v,154).id;
    const currVal_172:any = i1.ɵnov(_v,154).placeholder;
    const currVal_173:any = i1.ɵnov(_v,154).disabled;
    const currVal_174:any = i1.ɵnov(_v,154).required;
    const currVal_175:any = (i1.ɵnov(_v,154).ariaDescribedby || (null as any));
    _ck(_v,148,1,[currVal_163,currVal_164,currVal_165,currVal_166,currVal_167,currVal_168,
        currVal_169,currVal_170,currVal_171,currVal_172,currVal_173,currVal_174,currVal_175]);
    const currVal_178:any = (null as any);
    const currVal_179:any = true;
    const currVal_180:any = i1.ɵnov(_v,159)._isErrorState();
    const currVal_181:any = i1.ɵnov(_v,159)._mdInputChild.focused;
    const currVal_182:any = i1.ɵnov(_v,159)._shouldForward('untouched');
    const currVal_183:any = i1.ɵnov(_v,159)._shouldForward('touched');
    const currVal_184:any = i1.ɵnov(_v,159)._shouldForward('pristine');
    const currVal_185:any = i1.ɵnov(_v,159)._shouldForward('dirty');
    const currVal_186:any = i1.ɵnov(_v,159)._shouldForward('valid');
    const currVal_187:any = i1.ɵnov(_v,159)._shouldForward('invalid');
    const currVal_188:any = i1.ɵnov(_v,159)._shouldForward('pending');
    _ck(_v,158,1,[currVal_178,currVal_179,currVal_180,currVal_181,currVal_182,currVal_183,
        currVal_184,currVal_185,currVal_186,currVal_187,currVal_188]);
    const currVal_190:any = i1.ɵnov(_v,173).ngClassUntouched;
    const currVal_191:any = i1.ɵnov(_v,173).ngClassTouched;
    const currVal_192:any = i1.ɵnov(_v,173).ngClassPristine;
    const currVal_193:any = i1.ɵnov(_v,173).ngClassDirty;
    const currVal_194:any = i1.ɵnov(_v,173).ngClassValid;
    const currVal_195:any = i1.ɵnov(_v,173).ngClassInvalid;
    const currVal_196:any = i1.ɵnov(_v,173).ngClassPending;
    const currVal_197:any = true;
    const currVal_198:any = i1.ɵnov(_v,174).id;
    const currVal_199:any = i1.ɵnov(_v,174).placeholder;
    const currVal_200:any = i1.ɵnov(_v,174).disabled;
    const currVal_201:any = i1.ɵnov(_v,174).required;
    const currVal_202:any = (i1.ɵnov(_v,174).ariaDescribedby || (null as any));
    _ck(_v,168,1,[currVal_190,currVal_191,currVal_192,currVal_193,currVal_194,currVal_195,
        currVal_196,currVal_197,currVal_198,currVal_199,currVal_200,currVal_201,currVal_202]);
    const currVal_210:any = (null as any);
    const currVal_211:any = true;
    const currVal_212:any = i1.ɵnov(_v,185)._isErrorState();
    const currVal_213:any = i1.ɵnov(_v,185)._mdInputChild.focused;
    const currVal_214:any = i1.ɵnov(_v,185)._shouldForward('untouched');
    const currVal_215:any = i1.ɵnov(_v,185)._shouldForward('touched');
    const currVal_216:any = i1.ɵnov(_v,185)._shouldForward('pristine');
    const currVal_217:any = i1.ɵnov(_v,185)._shouldForward('dirty');
    const currVal_218:any = i1.ɵnov(_v,185)._shouldForward('valid');
    const currVal_219:any = i1.ɵnov(_v,185)._shouldForward('invalid');
    const currVal_220:any = i1.ɵnov(_v,185)._shouldForward('pending');
    _ck(_v,184,1,[currVal_210,currVal_211,currVal_212,currVal_213,currVal_214,currVal_215,
        currVal_216,currVal_217,currVal_218,currVal_219,currVal_220]);
    const currVal_222:any = i1.ɵnov(_v,199).ngClassUntouched;
    const currVal_223:any = i1.ɵnov(_v,199).ngClassTouched;
    const currVal_224:any = i1.ɵnov(_v,199).ngClassPristine;
    const currVal_225:any = i1.ɵnov(_v,199).ngClassDirty;
    const currVal_226:any = i1.ɵnov(_v,199).ngClassValid;
    const currVal_227:any = i1.ɵnov(_v,199).ngClassInvalid;
    const currVal_228:any = i1.ɵnov(_v,199).ngClassPending;
    const currVal_229:any = true;
    const currVal_230:any = i1.ɵnov(_v,200).id;
    const currVal_231:any = i1.ɵnov(_v,200).placeholder;
    const currVal_232:any = i1.ɵnov(_v,200).disabled;
    const currVal_233:any = i1.ɵnov(_v,200).required;
    const currVal_234:any = (i1.ɵnov(_v,200).ariaDescribedby || (null as any));
    _ck(_v,194,1,[currVal_222,currVal_223,currVal_224,currVal_225,currVal_226,currVal_227,
        currVal_228,currVal_229,currVal_230,currVal_231,currVal_232,currVal_233,currVal_234]);
    const currVal_237:any = (null as any);
    const currVal_238:any = true;
    const currVal_239:any = i1.ɵnov(_v,205)._isErrorState();
    const currVal_240:any = i1.ɵnov(_v,205)._mdInputChild.focused;
    const currVal_241:any = i1.ɵnov(_v,205)._shouldForward('untouched');
    const currVal_242:any = i1.ɵnov(_v,205)._shouldForward('touched');
    const currVal_243:any = i1.ɵnov(_v,205)._shouldForward('pristine');
    const currVal_244:any = i1.ɵnov(_v,205)._shouldForward('dirty');
    const currVal_245:any = i1.ɵnov(_v,205)._shouldForward('valid');
    const currVal_246:any = i1.ɵnov(_v,205)._shouldForward('invalid');
    const currVal_247:any = i1.ɵnov(_v,205)._shouldForward('pending');
    _ck(_v,204,1,[currVal_237,currVal_238,currVal_239,currVal_240,currVal_241,currVal_242,
        currVal_243,currVal_244,currVal_245,currVal_246,currVal_247]);
    const currVal_249:any = i1.ɵnov(_v,219).ngClassUntouched;
    const currVal_250:any = i1.ɵnov(_v,219).ngClassTouched;
    const currVal_251:any = i1.ɵnov(_v,219).ngClassPristine;
    const currVal_252:any = i1.ɵnov(_v,219).ngClassDirty;
    const currVal_253:any = i1.ɵnov(_v,219).ngClassValid;
    const currVal_254:any = i1.ɵnov(_v,219).ngClassInvalid;
    const currVal_255:any = i1.ɵnov(_v,219).ngClassPending;
    const currVal_256:any = true;
    const currVal_257:any = i1.ɵnov(_v,220).id;
    const currVal_258:any = i1.ɵnov(_v,220).placeholder;
    const currVal_259:any = i1.ɵnov(_v,220).disabled;
    const currVal_260:any = i1.ɵnov(_v,220).required;
    const currVal_261:any = (i1.ɵnov(_v,220).ariaDescribedby || (null as any));
    _ck(_v,214,1,[currVal_249,currVal_250,currVal_251,currVal_252,currVal_253,currVal_254,
        currVal_255,currVal_256,currVal_257,currVal_258,currVal_259,currVal_260,currVal_261]);
    const currVal_264:any = (null as any);
    const currVal_265:any = true;
    const currVal_266:any = i1.ɵnov(_v,225)._isErrorState();
    const currVal_267:any = i1.ɵnov(_v,225)._mdInputChild.focused;
    const currVal_268:any = i1.ɵnov(_v,225)._shouldForward('untouched');
    const currVal_269:any = i1.ɵnov(_v,225)._shouldForward('touched');
    const currVal_270:any = i1.ɵnov(_v,225)._shouldForward('pristine');
    const currVal_271:any = i1.ɵnov(_v,225)._shouldForward('dirty');
    const currVal_272:any = i1.ɵnov(_v,225)._shouldForward('valid');
    const currVal_273:any = i1.ɵnov(_v,225)._shouldForward('invalid');
    const currVal_274:any = i1.ɵnov(_v,225)._shouldForward('pending');
    _ck(_v,224,1,[currVal_264,currVal_265,currVal_266,currVal_267,currVal_268,currVal_269,
        currVal_270,currVal_271,currVal_272,currVal_273,currVal_274]);
    const currVal_276:any = (_co.currentProduct.unit_price_eur || 0);
    const currVal_277:any = true;
    const currVal_278:any = i1.ɵnov(_v,235).id;
    const currVal_279:any = i1.ɵnov(_v,235).placeholder;
    const currVal_280:any = i1.ɵnov(_v,235).disabled;
    const currVal_281:any = i1.ɵnov(_v,235).required;
    const currVal_282:any = (i1.ɵnov(_v,235).ariaDescribedby || (null as any));
    _ck(_v,234,0,currVal_276,currVal_277,currVal_278,currVal_279,currVal_280,currVal_281,
        currVal_282);
    const currVal_289:any = (null as any);
    const currVal_290:any = true;
    const currVal_291:any = i1.ɵnov(_v,246)._isErrorState();
    const currVal_292:any = i1.ɵnov(_v,246)._mdInputChild.focused;
    const currVal_293:any = i1.ɵnov(_v,246)._shouldForward('untouched');
    const currVal_294:any = i1.ɵnov(_v,246)._shouldForward('touched');
    const currVal_295:any = i1.ɵnov(_v,246)._shouldForward('pristine');
    const currVal_296:any = i1.ɵnov(_v,246)._shouldForward('dirty');
    const currVal_297:any = i1.ɵnov(_v,246)._shouldForward('valid');
    const currVal_298:any = i1.ɵnov(_v,246)._shouldForward('invalid');
    const currVal_299:any = i1.ɵnov(_v,246)._shouldForward('pending');
    _ck(_v,245,1,[currVal_289,currVal_290,currVal_291,currVal_292,currVal_293,currVal_294,
        currVal_295,currVal_296,currVal_297,currVal_298,currVal_299]);
    const currVal_301:any = i1.ɵnov(_v,260).ngClassUntouched;
    const currVal_302:any = i1.ɵnov(_v,260).ngClassTouched;
    const currVal_303:any = i1.ɵnov(_v,260).ngClassPristine;
    const currVal_304:any = i1.ɵnov(_v,260).ngClassDirty;
    const currVal_305:any = i1.ɵnov(_v,260).ngClassValid;
    const currVal_306:any = i1.ɵnov(_v,260).ngClassInvalid;
    const currVal_307:any = i1.ɵnov(_v,260).ngClassPending;
    const currVal_308:any = true;
    const currVal_309:any = i1.ɵnov(_v,261).id;
    const currVal_310:any = i1.ɵnov(_v,261).placeholder;
    const currVal_311:any = i1.ɵnov(_v,261).disabled;
    const currVal_312:any = i1.ɵnov(_v,261).required;
    const currVal_313:any = (i1.ɵnov(_v,261).ariaDescribedby || (null as any));
    _ck(_v,255,1,[currVal_301,currVal_302,currVal_303,currVal_304,currVal_305,currVal_306,
        currVal_307,currVal_308,currVal_309,currVal_310,currVal_311,currVal_312,currVal_313]);
  });
}
function View_PurchasingProductComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),36,'md-card',([] as any[]),
      [[2,'mat-card',(null as any)]],(null as any),(null as any),i6.View_MdCard_0,
      i6.RenderType_MdCard)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,
      i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i7.MdCard,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵeld(0,(null as any),0,28,
          'md-card-header',[['fxLayout','column']],[[2,'mat-card-header',(null as any)]],
          (null as any),(null as any),i6.View_MdCardHeader_0,i6.RenderType_MdCardHeader)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i7.MdCardHeader,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),1,15,'md-card-title',([] as any[]),[[2,'mat-card-title',
          (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardTitle,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          10,'span',[['class','md-title'],['fxFlex','100']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(737280,(null as any),
          0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i2.LayoutDirective],
              [3,i10.LayoutWrapDirective]],{flex:[0,'flex']},(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['',' /\n                        '])),
      i1.ɵppd(2),(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'a',([] as any[]),
          [[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,19).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i13.RouterLinkWithHref,
          [i13.Router,i13.ActivatedRoute,i11.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),[' / ','\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵted(2,['\n                '])),(_l()(),
          i1.ɵeld(0,(null as any),1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
              [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),
              (null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
          [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardSubtitle,([] as any[]),(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['',''])),i1.ɵppd(2),(_l()(),i1.ɵted(2,['\n            '])),(_l()(),i1.ɵted(0,
          ['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),
          View_PurchasingProductComponent_3)),i1.ɵdid(16384,(null as any),0,i11.NgIf,
          [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i1.ɵted(0,['\n        ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_2:any = 'column';
    _ck(_v,7,0,currVal_2);
    const currVal_4:any = '100';
    _ck(_v,14,0,currVal_4);
    const currVal_5:any = 'md-title';
    _ck(_v,15,0,currVal_5);
    const currVal_9:any = _ck(_v,20,0,'/purchasing/products');
    _ck(_v,19,0,currVal_9);
    const currVal_13:any = 'bg-grey color-white text-only';
    _ck(_v,29,0,currVal_13);
    const currVal_15:any = _co.currentProduct;
    _ck(_v,35,0,currVal_15);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = true;
    _ck(_v,4,0,currVal_1);
    const currVal_3:any = true;
    _ck(_v,9,0,currVal_3);
    const currVal_6:any = i1.ɵunv(_v,16,0,_ck(_v,17,0,i1.ɵnov((<any>_v.parent),0),
        'purchasing',_co._authService.getLanguage()));
    _ck(_v,16,0,currVal_6);
    const currVal_7:any = i1.ɵnov(_v,19).target;
    const currVal_8:any = i1.ɵnov(_v,19).href;
    _ck(_v,18,0,currVal_7,currVal_8);
    const currVal_10:any = i1.ɵunv(_v,21,0,_ck(_v,22,0,i1.ɵnov((<any>_v.parent),0),
        'all_products',_co._authService.getLanguage()));
    _ck(_v,21,0,currVal_10);
    const currVal_11:any = ((_co.isEditMode && _co.currentProduct)? ((((_co.currentProduct.collection_name + ' - ') + _co.currentProduct.design_name) + ' - ') + _co.currentProduct.name): _co.title);
    _ck(_v,23,0,currVal_11);
    const currVal_12:any = true;
    _ck(_v,26,0,currVal_12);
    const currVal_14:any = i1.ɵunv(_v,30,0,_ck(_v,31,0,i1.ɵnov((<any>_v.parent),0),
        'product_detail',_co._authService.getLanguage()));
    _ck(_v,30,0,currVal_14);
  });
}
function View_PurchasingProductComponent_13(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[60,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['','']))],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit.id;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_10);
  });
}
function View_PurchasingProductComponent_12(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),84,'md-card-content',
      ([] as any[]),[[2,'mat-card-content',(null as any)]],(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardContent,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),79,'div',[['class','padded-container'],['fxLayout','row'],
              ['fxLayout.lt-md','column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md',
                  '14px']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},
          (null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,
          'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          12,'md-select',[['fxFlex','22%'],['name','supplierType'],['role','listbox']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[1,'tabindex',
                  0],[1,'aria-label',0],[1,'aria-labelledby',0],[1,'aria-required',
                  0],[1,'aria-disabled',0],[1,'aria-invalid',0],[1,'aria-owns',0],
              [2,'mat-select-disabled',(null as any)],[2,'mat-select',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'keydown'],[(null as any),
              'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,14)._handleClosedKeydown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,14)._onBlur()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.currentProduct.supplier_id = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i6.View_MdSelect_0,i6.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),
          0,i8.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,(null as any)]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i8.NgControl,(null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),
          0,i8.NgControlStatus,[i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          1,i7.MdSelect,[i1.ElementRef,i1.Renderer2,i7.ViewportRuler,i1.ChangeDetectorRef,
              [2,i7.Dir],[2,i8.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵqud(603979776,60,{options:1}),i1.ɵppd(2),i1.ɵdid(737280,
          (null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,'flex']},
          (null as any)),(_l()(),i1.ɵted(0,['\n                        '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,1,(null as any),View_PurchasingProductComponent_13)),
      i1.ɵdid(802816,(null as any),0,i11.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),18,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,25)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,61,{_mdInputChild:0}),i1.ɵqud(335544320,62,{_placeholderChild:0}),
      i1.ɵqud(603979776,63,{_errorChildren:1}),i1.ɵqud(603979776,64,{_hintChildren:1}),
      i1.ɵqud(603979776,65,{_prefixChildren:1}),i1.ɵqud(603979776,66,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,35)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,35).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,35)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,35)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,40)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,40)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,40)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentProduct.collection_supplier_name = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[61,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),18,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,45)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,67,{_mdInputChild:0}),i1.ɵqud(335544320,68,{_placeholderChild:0}),
      i1.ɵqud(603979776,69,{_errorChildren:1}),i1.ɵqud(603979776,70,{_hintChildren:1}),
      i1.ɵqud(603979776,71,{_prefixChildren:1}),i1.ɵqud(603979776,72,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,55)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,55).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,55)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,55)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,60)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,60)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,60)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentProduct.design_supplier_name = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[67,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),18,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,65)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,73,{_mdInputChild:0}),i1.ɵqud(335544320,74,{_placeholderChild:0}),
      i1.ɵqud(603979776,75,{_errorChildren:1}),i1.ɵqud(603979776,76,{_hintChildren:1}),
      i1.ɵqud(603979776,77,{_prefixChildren:1}),i1.ɵqud(603979776,78,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,75)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,75).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,75)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,75)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,80)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,80)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,80)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentProduct.color_supplier_name = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[73,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n            ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'row';
    const currVal_2:any = 'column';
    _ck(_v,5,0,currVal_1,currVal_2);
    const currVal_3:any = '30px';
    const currVal_4:any = '14px';
    _ck(_v,6,0,currVal_3,currVal_4);
    const currVal_5:any = 'padded-container';
    _ck(_v,7,0,currVal_5);
    const currVal_22:any = 'supplierType';
    const currVal_23:any = _co.currentProduct.supplier_id;
    _ck(_v,10,0,currVal_22,currVal_23);
    const currVal_24:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,14,0,_ck(_v,16,0,
        i1.ɵnov((<any>_v.parent),0),'supplier',_co._authService.getLanguage())),'');
    _ck(_v,14,0,currVal_24);
    const currVal_25:any = '22%';
    _ck(_v,17,0,currVal_25);
    const currVal_26:any = _co.allSuppliers;
    _ck(_v,20,0,currVal_26);
    const currVal_38:any = '22%';
    _ck(_v,32,0,currVal_38);
    const currVal_52:any = _co.currentProduct.collection_supplier_name;
    _ck(_v,37,0,currVal_52);
    const currVal_53:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,40,0,_ck(_v,41,0,
        i1.ɵnov((<any>_v.parent),0),'collection',_co._authService.getLanguage())),
        '');
    _ck(_v,40,0,currVal_53);
    const currVal_65:any = '22%';
    _ck(_v,52,0,currVal_65);
    const currVal_79:any = _co.currentProduct.design_supplier_name;
    _ck(_v,57,0,currVal_79);
    const currVal_80:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,60,0,_ck(_v,61,0,
        i1.ɵnov((<any>_v.parent),0),'design',_co._authService.getLanguage())),'');
    _ck(_v,60,0,currVal_80);
    const currVal_92:any = '22%';
    _ck(_v,72,0,currVal_92);
    const currVal_106:any = _co.currentProduct.color_supplier_name;
    _ck(_v,77,0,currVal_106);
    const currVal_107:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,80,0,_ck(_v,81,0,
        i1.ɵnov((<any>_v.parent),0),'color',_co._authService.getLanguage())),'');
    _ck(_v,80,0,currVal_107);
  },(_ck,_v) => {
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_6:any = i1.ɵnov(_v,12).ngClassUntouched;
    const currVal_7:any = i1.ɵnov(_v,12).ngClassTouched;
    const currVal_8:any = i1.ɵnov(_v,12).ngClassPristine;
    const currVal_9:any = i1.ɵnov(_v,12).ngClassDirty;
    const currVal_10:any = i1.ɵnov(_v,12).ngClassValid;
    const currVal_11:any = i1.ɵnov(_v,12).ngClassInvalid;
    const currVal_12:any = i1.ɵnov(_v,12).ngClassPending;
    const currVal_13:any = i1.ɵnov(_v,14).tabIndex;
    const currVal_14:any = i1.ɵnov(_v,14)._ariaLabel;
    const currVal_15:any = i1.ɵnov(_v,14).ariaLabelledby;
    const currVal_16:any = i1.ɵnov(_v,14).required.toString();
    const currVal_17:any = i1.ɵnov(_v,14).disabled.toString();
    const currVal_18:any = (((i1.ɵnov(_v,14)._control == null)? (null as any): i1.ɵnov(_v,
        14)._control.invalid) || 'false');
    const currVal_19:any = i1.ɵnov(_v,14)._optionIds;
    const currVal_20:any = i1.ɵnov(_v,14).disabled;
    const currVal_21:any = true;
    _ck(_v,9,1,[currVal_6,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,
        currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,currVal_18,currVal_19,
        currVal_20,currVal_21]);
    const currVal_27:any = (null as any);
    const currVal_28:any = true;
    const currVal_29:any = i1.ɵnov(_v,25)._isErrorState();
    const currVal_30:any = i1.ɵnov(_v,25)._mdInputChild.focused;
    const currVal_31:any = i1.ɵnov(_v,25)._shouldForward('untouched');
    const currVal_32:any = i1.ɵnov(_v,25)._shouldForward('touched');
    const currVal_33:any = i1.ɵnov(_v,25)._shouldForward('pristine');
    const currVal_34:any = i1.ɵnov(_v,25)._shouldForward('dirty');
    const currVal_35:any = i1.ɵnov(_v,25)._shouldForward('valid');
    const currVal_36:any = i1.ɵnov(_v,25)._shouldForward('invalid');
    const currVal_37:any = i1.ɵnov(_v,25)._shouldForward('pending');
    _ck(_v,24,1,[currVal_27,currVal_28,currVal_29,currVal_30,currVal_31,currVal_32,
        currVal_33,currVal_34,currVal_35,currVal_36,currVal_37]);
    const currVal_39:any = i1.ɵnov(_v,39).ngClassUntouched;
    const currVal_40:any = i1.ɵnov(_v,39).ngClassTouched;
    const currVal_41:any = i1.ɵnov(_v,39).ngClassPristine;
    const currVal_42:any = i1.ɵnov(_v,39).ngClassDirty;
    const currVal_43:any = i1.ɵnov(_v,39).ngClassValid;
    const currVal_44:any = i1.ɵnov(_v,39).ngClassInvalid;
    const currVal_45:any = i1.ɵnov(_v,39).ngClassPending;
    const currVal_46:any = true;
    const currVal_47:any = i1.ɵnov(_v,40).id;
    const currVal_48:any = i1.ɵnov(_v,40).placeholder;
    const currVal_49:any = i1.ɵnov(_v,40).disabled;
    const currVal_50:any = i1.ɵnov(_v,40).required;
    const currVal_51:any = (i1.ɵnov(_v,40).ariaDescribedby || (null as any));
    _ck(_v,34,1,[currVal_39,currVal_40,currVal_41,currVal_42,currVal_43,currVal_44,
        currVal_45,currVal_46,currVal_47,currVal_48,currVal_49,currVal_50,currVal_51]);
    const currVal_54:any = (null as any);
    const currVal_55:any = true;
    const currVal_56:any = i1.ɵnov(_v,45)._isErrorState();
    const currVal_57:any = i1.ɵnov(_v,45)._mdInputChild.focused;
    const currVal_58:any = i1.ɵnov(_v,45)._shouldForward('untouched');
    const currVal_59:any = i1.ɵnov(_v,45)._shouldForward('touched');
    const currVal_60:any = i1.ɵnov(_v,45)._shouldForward('pristine');
    const currVal_61:any = i1.ɵnov(_v,45)._shouldForward('dirty');
    const currVal_62:any = i1.ɵnov(_v,45)._shouldForward('valid');
    const currVal_63:any = i1.ɵnov(_v,45)._shouldForward('invalid');
    const currVal_64:any = i1.ɵnov(_v,45)._shouldForward('pending');
    _ck(_v,44,1,[currVal_54,currVal_55,currVal_56,currVal_57,currVal_58,currVal_59,
        currVal_60,currVal_61,currVal_62,currVal_63,currVal_64]);
    const currVal_66:any = i1.ɵnov(_v,59).ngClassUntouched;
    const currVal_67:any = i1.ɵnov(_v,59).ngClassTouched;
    const currVal_68:any = i1.ɵnov(_v,59).ngClassPristine;
    const currVal_69:any = i1.ɵnov(_v,59).ngClassDirty;
    const currVal_70:any = i1.ɵnov(_v,59).ngClassValid;
    const currVal_71:any = i1.ɵnov(_v,59).ngClassInvalid;
    const currVal_72:any = i1.ɵnov(_v,59).ngClassPending;
    const currVal_73:any = true;
    const currVal_74:any = i1.ɵnov(_v,60).id;
    const currVal_75:any = i1.ɵnov(_v,60).placeholder;
    const currVal_76:any = i1.ɵnov(_v,60).disabled;
    const currVal_77:any = i1.ɵnov(_v,60).required;
    const currVal_78:any = (i1.ɵnov(_v,60).ariaDescribedby || (null as any));
    _ck(_v,54,1,[currVal_66,currVal_67,currVal_68,currVal_69,currVal_70,currVal_71,
        currVal_72,currVal_73,currVal_74,currVal_75,currVal_76,currVal_77,currVal_78]);
    const currVal_81:any = (null as any);
    const currVal_82:any = true;
    const currVal_83:any = i1.ɵnov(_v,65)._isErrorState();
    const currVal_84:any = i1.ɵnov(_v,65)._mdInputChild.focused;
    const currVal_85:any = i1.ɵnov(_v,65)._shouldForward('untouched');
    const currVal_86:any = i1.ɵnov(_v,65)._shouldForward('touched');
    const currVal_87:any = i1.ɵnov(_v,65)._shouldForward('pristine');
    const currVal_88:any = i1.ɵnov(_v,65)._shouldForward('dirty');
    const currVal_89:any = i1.ɵnov(_v,65)._shouldForward('valid');
    const currVal_90:any = i1.ɵnov(_v,65)._shouldForward('invalid');
    const currVal_91:any = i1.ɵnov(_v,65)._shouldForward('pending');
    _ck(_v,64,1,[currVal_81,currVal_82,currVal_83,currVal_84,currVal_85,currVal_86,
        currVal_87,currVal_88,currVal_89,currVal_90,currVal_91]);
    const currVal_93:any = i1.ɵnov(_v,79).ngClassUntouched;
    const currVal_94:any = i1.ɵnov(_v,79).ngClassTouched;
    const currVal_95:any = i1.ɵnov(_v,79).ngClassPristine;
    const currVal_96:any = i1.ɵnov(_v,79).ngClassDirty;
    const currVal_97:any = i1.ɵnov(_v,79).ngClassValid;
    const currVal_98:any = i1.ɵnov(_v,79).ngClassInvalid;
    const currVal_99:any = i1.ɵnov(_v,79).ngClassPending;
    const currVal_100:any = true;
    const currVal_101:any = i1.ɵnov(_v,80).id;
    const currVal_102:any = i1.ɵnov(_v,80).placeholder;
    const currVal_103:any = i1.ɵnov(_v,80).disabled;
    const currVal_104:any = i1.ɵnov(_v,80).required;
    const currVal_105:any = (i1.ɵnov(_v,80).ariaDescribedby || (null as any));
    _ck(_v,74,1,[currVal_93,currVal_94,currVal_95,currVal_96,currVal_97,currVal_98,
        currVal_99,currVal_100,currVal_101,currVal_102,currVal_103,currVal_104,currVal_105]);
  });
}
function View_PurchasingProductComponent_14(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),15,'div',[['class',
      'image-preview-i']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,
      i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
      {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'img',[['class','image']],[[8,
          'src',4]],(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),8,'div',[['class','image-header'],
          ['flex',''],['layout','row'],['layout-align','end center']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-icon',[['class','linkCursor'],
          ['role','img']],[[2,'mat-icon',(null as any)]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.removePicture(_v.context.$implicit)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdIcon_0,i6.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,
          i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
          (null as any)),i1.ɵdid(9027584,(null as any),0,i7.MdIcon,[i1.ElementRef,
          i1.Renderer2,i7.MdIconRegistry],(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['clear'])),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n                ']))],
      (_ck,_v) => {
        const currVal_0:any = 'image-preview-i';
        _ck(_v,1,0,currVal_0);
        const currVal_2:any = 'image';
        _ck(_v,4,0,currVal_2);
        const currVal_3:any = 'image-header';
        _ck(_v,7,0,currVal_3);
        _ck(_v,11,0);
        const currVal_5:any = 'linkCursor';
        _ck(_v,12,0,currVal_5);
      },(_ck,_v) => {
        const currVal_1:any = _v.context.$implicit;
        _ck(_v,3,0,currVal_1);
        const currVal_4:any = true;
        _ck(_v,9,0,currVal_4);
      });
}
function View_PurchasingProductComponent_15(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['',''])),i1.ɵppd(2)],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵunv(_v,1,0,_ck(_v,2,0,i1.ɵnov((<any>_v.parent),0),'files_selected',
        _co._authService.getLanguage()));
    _ck(_v,1,0,currVal_0);
  });
}
function View_PurchasingProductComponent_16(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted((null as any),['\n                            '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-icon',[['role','img']],[[2,
          'mat-icon',(null as any)]],(null as any),(null as any),i6.View_MdIcon_0,
          i6.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
          [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i7.MdIcon,[i1.ElementRef,i1.Renderer2,i7.MdIconRegistry],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['attach_file'])),(_l()(),
          i1.ɵted((null as any),['\n                            '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),2,'span',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['','...'])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),['\n                        ']))],
      (_ck,_v) => {
        _ck(_v,3,0);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = true;
        _ck(_v,1,0,currVal_0);
        const currVal_1:any = i1.ɵunv(_v,7,0,_ck(_v,8,0,i1.ɵnov((<any>_v.parent),0),
            'choose_image',_co._authService.getLanguage()));
        _ck(_v,7,0,currVal_1);
      });
}
function View_PurchasingProductComponent_18(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.createProduct()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i7.MdButton,[i1.ElementRef,i1.Renderer2,i7.Platform,
          i7.FocusOriginMonitor],{color:[0,'color']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],(_ck,
      _v) => {
    const currVal_1:any = 'primary';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'bg-blue color-white';
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        0),'create',_co._authService.getLanguage()));
    _ck(_v,5,0,currVal_3);
  });
}
function View_PurchasingProductComponent_19(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.saveProduct()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i7.MdButton,[i1.ElementRef,i1.Renderer2,i7.Platform,
          i7.FocusOriginMonitor],{color:[0,'color']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],(_ck,
      _v) => {
    const currVal_1:any = 'primary';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'bg-blue color-white';
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        0),'save_data',_co._authService.getLanguage()));
    _ck(_v,5,0,currVal_3);
  });
}
function View_PurchasingProductComponent_17(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),24,'md-card-actions',
      ([] as any[]),[[2,'mat-card-actions',(null as any)]],(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardActions,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),19,'div',[['class','table-control-buttons'],['fxFlex',''],
              ['fxFlexAlign','start'],['fxFlexAlign.lt-md','center'],['fxLayoutGap',
                  '12px']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[8,(null as any)]],{gap:[0,'gap']},(null as any)),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),i1.ɵdid(737280,(null as any),0,i14.FlexAlignDirective,
          [i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{align:[0,'align'],alignLtMd:[1,
              'alignLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_PurchasingProductComponent_18)),i1.ɵdid(16384,(null as any),
          0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n                    '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_PurchasingProductComponent_19)),
      i1.ɵdid(16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class','bg-red color-white mat-button'],
          ['color','warn'],['md-button','']],[[8,'disabled',0]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.goBack()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i7.MdButton,
          [i1.ElementRef,i1.Renderer2,i7.Platform,i7.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i7.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵted((null as any),['\n            ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = '12px';
        _ck(_v,5,0,currVal_1);
        const currVal_2:any = '';
        _ck(_v,6,0,currVal_2);
        const currVal_3:any = 'start';
        const currVal_4:any = 'center';
        _ck(_v,7,0,currVal_3,currVal_4);
        const currVal_5:any = 'table-control-buttons';
        _ck(_v,8,0,currVal_5);
        const currVal_6:boolean = !_co.isEditMode;
        _ck(_v,11,0,currVal_6);
        const currVal_7:any = _co.isEditMode;
        _ck(_v,14,0,currVal_7);
        const currVal_9:any = 'warn';
        _ck(_v,18,0,currVal_9);
        const currVal_10:any = 'bg-red color-white';
        _ck(_v,20,0,currVal_10);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = true;
        _ck(_v,0,0,currVal_0);
        const currVal_8:any = (i1.ɵnov(_v,18).disabled || (null as any));
        _ck(_v,16,0,currVal_8);
        const currVal_11:any = i1.ɵunv(_v,21,0,_ck(_v,22,0,i1.ɵnov((<any>_v.parent),
            0),'back',_co._authService.getLanguage()));
        _ck(_v,21,0,currVal_11);
      });
}
export function View_PurchasingProductComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i15.TranslatePipe,([] as any[])),i1.ɵqud(402653184,1,
      {fileUpload:0}),(_l()(),i1.ɵeld(0,(null as any),(null as any),93,'div',[['fxLayout',
      'column']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n    \n\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_PurchasingProductComponent_1)),i1.ɵdid(16384,(null as any),
          0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n\n    '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),86,'div',[['class','boxed-content-wrapper cards-no-gaps']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PurchasingProductComponent_2)),
      i1.ɵdid(212992,(null as any),0,i16.TdLoadingDirective,[i1.ViewContainerRef,i1.TemplateRef,
          i17.TdLoadingService],{name:[0,'name'],type:[1,'type'],mode:[2,'mode'],strategy:[3,
          'strategy'],color:[4,'color']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),19,'md-card',
          ([] as any[]),[[2,'mat-card',(null as any)]],(null as any),(null as any),
          i6.View_MdCard_0,i6.RenderType_MdCard)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
          [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i7.MdCard,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵeld(0,(null as any),0,11,
          'md-card-header',[['fxLayout','column']],[[2,'mat-card-header',(null as any)]],
          (null as any),(null as any),i6.View_MdCardHeader_0,i6.RenderType_MdCardHeader)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i7.MdCardHeader,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
          [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardSubtitle,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),(_l()(),
          i1.ɵted(2,['\n            '])),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,1,(null as any),View_PurchasingProductComponent_12)),
      i1.ɵdid(16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(0,['\n        '])),(_l()(),
          i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          58,'md-card',[['class','product-new-picture-card']],[[2,'mat-card',(null as any)]],
          (null as any),(null as any),i6.View_MdCard_0,i6.RenderType_MdCard)),i1.ɵdid(16384,
          (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i7.MdCard,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),0,11,'md-card-header',[['fxLayout','column']],[[2,'mat-card-header',
              (null as any)]],(null as any),(null as any),i6.View_MdCardHeader_0,i6.RenderType_MdCardHeader)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i7.MdCardHeader,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
          [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardSubtitle,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),(_l()(),
          i1.ɵted(2,['\n            '])),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),
          i1.ɵeld(0,(null as any),0,8,'div',[['class','image-previews'],['fxLayout',
              'row'],['fxLayout.lt-md','row wrap'],['fxLayoutGap','16px'],['layout-margin',
              ''],['layout-padding','']],(null as any),(null as any),(null as any),
              (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,
          [i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,
              'layoutLtMd']},(null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,
          [i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,
              'gap']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PurchasingProductComponent_14)),
      i1.ɵdid(802816,(null as any),0,i11.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n\n            '])),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),0,26,'md-card-content',([] as any[]),[[2,'mat-card-content',
              (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardContent,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),21,
          'div',[['class','padded-container']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          17,'td-file-upload',[['accept','.png,.jpg,.jpeg,'],['activeColor','warn'],
              ['cancelColor','primary'],['defaultColor','accent']],(null as any),[[(null as any),
              'select'],[(null as any),'upload'],[(null as any),'cancel']],(_v,en,
              $event) => {
            var ad:boolean = true;
            var _co:i18.PurchasingProductComponent = _v.component;
            if (('select' === en)) {
              const pd_0:any = ((<any>_co.selectEvent($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('upload' === en)) {
              const pd_1:any = ((<any>_co.uploadEvent($event)) !== false);
              ad = (pd_1 && ad);
            }
            if (('cancel' === en)) {
              const pd_2:any = ((<any>_co.cancelEvent()) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i19.View_TdFileUploadComponent_0,i19.RenderType_TdFileUploadComponent)),
      i1.ɵdid(49152,[[1,4],['fileUpload',4]],1,i20.TdFileUploadComponent,[i1.ChangeDetectorRef],
          {defaultColor:[0,'defaultColor'],activeColor:[1,'activeColor'],cancelColor:[2,
              'cancelColor'],accept:[3,'accept'],disabled:[4,'disabled']},{onSelect:'select',
              onUpload:'upload',onCancel:'cancel'}),i1.ɵqud(335544320,79,{inputLabel:0}),
      (_l()(),i1.ɵted(0,['\n                        '])),(_l()(),i1.ɵeld(0,(null as any),
          0,3,'md-icon',[['role','img']],[[2,'mat-icon',(null as any)]],(null as any),
          (null as any),i6.View_MdIcon_0,i6.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(9027584,(null as any),0,i7.MdIcon,[i1.ElementRef,
          i1.Renderer2,i7.MdIconRegistry],(null as any),(null as any)),(_l()(),i1.ɵted(0,
          ['file_upload'])),(_l()(),i1.ɵted(0,['\n                        '])),(_l()(),
          i1.ɵeld(0,(null as any),0,4,'span',([] as any[]),(null as any),(null as any),
              (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n                            ','\n                            '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PurchasingProductComponent_15)),
      i1.ɵdid(16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                        '])),
      (_l()(),i1.ɵted(0,['\n                        '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,1,(null as any),View_PurchasingProductComponent_16)),i1.ɵdid(16384,
          [[79,4]],0,i21.TdFileInputLabelDirective,[i1.TemplateRef,i1.ViewContainerRef],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,1,(null as any),View_PurchasingProductComponent_17)),i1.ɵdid(16384,
          (null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(0,['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i18.PurchasingProductComponent = _v.component;
    const currVal_0:any = 'column';
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _co.changed();
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = 'boxed-content-wrapper cards-no-gaps';
    _ck(_v,9,0,currVal_2);
    const currVal_3:any = 'loading';
    const currVal_4:any = 'circle';
    const currVal_5:any = 'indeterminate';
    const currVal_6:any = 'overlay';
    const currVal_7:any = 'accent';
    _ck(_v,12,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
    const currVal_10:any = 'column';
    _ck(_v,21,0,currVal_10);
    const currVal_12:any = 'bg-grey color-white text-only';
    _ck(_v,26,0,currVal_12);
    const currVal_14:any = _co.currentProduct;
    _ck(_v,32,0,currVal_14);
    const currVal_16:any = 'product-new-picture-card';
    _ck(_v,38,0,currVal_16);
    const currVal_18:any = 'column';
    _ck(_v,43,0,currVal_18);
    const currVal_20:any = 'bg-grey color-white text-only';
    _ck(_v,48,0,currVal_20);
    const currVal_22:any = 'row';
    const currVal_23:any = 'row wrap';
    _ck(_v,54,0,currVal_22,currVal_23);
    const currVal_24:any = '16px';
    _ck(_v,55,0,currVal_24);
    const currVal_25:any = 'image-previews';
    _ck(_v,56,0,currVal_25);
    const currVal_26:any = _co.currentProduct.attachments;
    _ck(_v,60,0,currVal_26);
    const currVal_28:any = 'padded-container';
    _ck(_v,68,0,currVal_28);
    const currVal_29:any = 'accent';
    const currVal_30:any = 'warn';
    const currVal_31:any = 'primary';
    const currVal_32:any = '.png,.jpg,.jpeg,';
    const currVal_33:any = false;
    _ck(_v,71,0,currVal_29,currVal_30,currVal_31,currVal_32,currVal_33);
    _ck(_v,76,0);
    const currVal_36:any = ((i1.ɵnov(_v,71).files == null)? (null as any): i1.ɵnov(_v,
        71).files.length);
    _ck(_v,82,0,currVal_36);
    const currVal_37:boolean = !_co._authService.isViewer();
    _ck(_v,92,0,currVal_37);
  },(_ck,_v) => {
    var _co:i18.PurchasingProductComponent = _v.component;
    const currVal_8:any = true;
    _ck(_v,14,0,currVal_8);
    const currVal_9:any = true;
    _ck(_v,18,0,currVal_9);
    const currVal_11:any = true;
    _ck(_v,23,0,currVal_11);
    const currVal_13:any = i1.ɵunv(_v,27,0,_ck(_v,28,0,i1.ɵnov(_v,0),'supplier_product_detail',
        _co._authService.getLanguage()));
    _ck(_v,27,0,currVal_13);
    const currVal_15:any = true;
    _ck(_v,35,0,currVal_15);
    const currVal_17:any = true;
    _ck(_v,40,0,currVal_17);
    const currVal_19:any = true;
    _ck(_v,45,0,currVal_19);
    const currVal_21:any = i1.ɵunv(_v,49,0,_ck(_v,50,0,i1.ɵnov(_v,0),'picture',_co._authService.getLanguage()));
    _ck(_v,49,0,currVal_21);
    const currVal_27:any = true;
    _ck(_v,63,0,currVal_27);
    const currVal_34:any = true;
    _ck(_v,74,0,currVal_34);
    const currVal_35:any = (((i1.ɵnov(_v,71).files == null)? (null as any): i1.ɵnov(_v,
        71).files.name) || ((i1.ɵnov(_v,71).files == null)? (null as any): i1.ɵnov(_v,
        71).files.length));
    _ck(_v,80,0,currVal_35);
  });
}
export function View_PurchasingProductComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'app-purchasing-product',
      ([] as any[]),(null as any),(null as any),(null as any),View_PurchasingProductComponent_0,
      RenderType_PurchasingProductComponent)),i1.ɵprd(512,(null as any),i22.FileUploadService,
      i22.FileUploadService,[i23.Http,i24.Configuration,i25.AuthenticationService]),
      i1.ɵdid(114688,(null as any),0,i18.PurchasingProductComponent,[i26.ProductService,
          i27.SupplierService,i28.LocationService,i22.FileUploadService,i29.TdDialogService,
          i17.TdLoadingService,i13.ActivatedRoute,i13.Router,i11.Location,i25.AuthenticationService],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const PurchasingProductComponentNgFactory:i1.ComponentFactory<i18.PurchasingProductComponent> = i1.ɵccf('app-purchasing-product',
    i18.PurchasingProductComponent,View_PurchasingProductComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/purchasing/products/product/purchasing-product.component.ngfactory.ts